import { faFileInvoice, faList } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Flex from 'components/common/Flex';
import { useRef, useState } from 'react';
import { Card, Nav, Tab } from 'react-bootstrap';
import SimpleBar from 'simplebar-react';
import Billing from './Billing';
import InvoiceList from './InvoiceList';

const BillingManagementPage = () => {
  const [activeTab, setActiveTab] = useState('billable-items');
  const invoiceListRef = useRef(null);

  const handleSwitchToInvoicesTab = () => {
    setActiveTab('invoices');
    // Forçar refetch da lista de faturas após um pequeno delay
    setTimeout(() => {
      if (invoiceListRef.current) {
        invoiceListRef.current.refetch();
      }
    }, 100);
  };

  return (
    <>
      <Card>
        <Flex className="p-3" justifyContent="between" alignItems="center">
          <h3 className="m-0">Faturamento</h3>
        </Flex>
        <Tab.Container
          activeKey={activeTab}
          onSelect={key => setActiveTab(key)}
        >
          <SimpleBar>
            <Card.Header className="p-0">
              <Nav className="nav-tabs border-0 flex-nowrap tab-contact-details">
                <Nav.Item>
                  <Nav.Link
                    eventKey="billable-items"
                    className="d-flex align-items-center py-3 px-x1 mb-0"
                  >
                    <FontAwesomeIcon
                      icon={faList}
                      className="text-600 tab-icon"
                    />
                    <h6 className="text-600 mb-0 ms-1">Itens Faturáveis</h6>
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link
                    eventKey="invoices"
                    className="d-flex align-items-center py-3 px-x1 mb-0"
                  >
                    <FontAwesomeIcon
                      icon={faFileInvoice}
                      className="text-600 tab-icon"
                    />
                    <h6 className="text-600 mb-0 ms-1">Faturas</h6>
                  </Nav.Link>
                </Nav.Item>
              </Nav>
            </Card.Header>
          </SimpleBar>
          <Card.Body className="pb-0">
            <Tab.Content>
              <Tab.Pane eventKey="billable-items">
                <Billing onGenerateInvoice={handleSwitchToInvoicesTab} />
              </Tab.Pane>
              <Tab.Pane eventKey="invoices">
                <InvoiceList ref={invoiceListRef} />
              </Tab.Pane>
            </Tab.Content>
          </Card.Body>
        </Tab.Container>
      </Card>
    </>
  );
};

export default BillingManagementPage;
